<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-if="show">
    <vue-plotly :data="plotData" :layout="layout" :options="options"/>
  </div>
  <div v-else class="align-center justify-center black--text">
    <v-img
        class="align-center"
        max-height="100"
        max-width="65"
        src="/reo_pics/error.png"
    ></v-img>
  </div>
</template>

<script>
import VuePlotly from '@statnett/vue-plotly';
import {mapGetters} from 'vuex';
import {config} from '@/store/config';

export default {
  name: 'top6Graph',

  components: {
    VuePlotly,
  },

  props: [],
  methods: {
    selected_product() {
      if (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
              .HS6_Code.length > 0
      ) {
        return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
            .products.HS6_Code[0];
      } else return '';
    },
    target_market() {
      return this.codeToMarket(
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
              .C_Code[0],
      );
    },
  },
  computed: {
    ...mapGetters(['app_data', 'selectionCounts']),

    countryNamesLink: function () {
      // return this.$store.getters.top6PlotData["x"];
      let cArray = [];
      let i = 1;
      let top_6_total = 0
      let perc_array = ["[0.00%]", "[0.00%]", "[0.00%]", "[0.00%]", "[0.00%]", "[0.00%]", "[0.00%]", "[0.00%]"]

      if (this.$store.state.tradeDSM.dsm_filter_setttings.results['top6'][0].hasOwnProperty('Trade_Value')) {
        for (i = 0; i <= 7; i++) {
          let trade_value = this.$store.state.tradeDSM.dsm_filter_setttings.results['top6'][i]['Trade_Value'];
          top_6_total += trade_value;
        }

        if (top_6_total > 0) {
          //make sure the total is not 0, as we will divide by it
          for (i = 0; i <= 7; i++) {
            // create an array of percentages
            let trade_value = this.$store.state.tradeDSM.dsm_filter_setttings.results['top6'][i]['Trade_Value']
            let v = trade_value / top_6_total * 100
            perc_array[i] = (" [" + v.toFixed(2) + "%]")
          }
        }
      }

      console.log(perc_array);
      let cntr = -1
      for (const m of this.$store.state.tradeDSM.dsm_filter_setttings.results['top6']) {
        for (const c of this.$store.state.tradeDSM.quick_selectors[0].items) {
          if (c['C_Code'] === m['Supplying_Market']) {
            cntr += 1
            cArray.push(c['C_Name'] + perc_array[cntr]);
          }
        }
        if (m['Supplying_Market'] === '-') {
          let tmp = '';
          for (let j = 0; j < i; j++) {
            tmp = tmp.concat(' ');
          }
          tmp = tmp.concat('-');
          cArray.push(tmp);
          // cArray.push('No competitor - ' + i.toString());
        }
        i += 1;
      }
      cArray[7] = 'Rest ' + perc_array[7];
      cArray[6] = this.$store.state.app.selectedHomeCountry + perc_array[6];

      // this is where the main arrray lives
      this.$store.commit('setTop6ResultCountries', cArray);

      return cArray;
    },
    plotData: function () {
      return [
        {
          type: 'bar',
          y: this.countryNamesLink,

          x: this.array_value_conversion(this.$store.getters.top6PlotData['y'], null),

          orientation: 'h',
          marker: {
            // color: ['red', 'red', 'red', 'red', 'red', 'red', '#1f3c5f', 'orange'],
            color: config.plot_top6_colors,
          },
        },
      ];
    },
    show: function () {
      return true;
    },
    layout: function () {
      return {
        //paper_bgcolor: '#7f7f7f',
        //plot_bgcolor: '#c7c7c7',
        title: {
          text:
              'Major competing markets supplying ' +
              this.selected_product() +
              '<br> into ' +
              this.target_market(),
          font: {
            size: 11,
            color: 'black',
          },
        },

        yaxis: {
          autorange: 'reversed',
          type: 'category',
          fixedrange: true,

          tickfont: {size: 9},
          // side: 'right',
        },

        bargap: 0.4,
        height: '300',
        width: '400',
        autosize: true,
        margin: {
          l: 170,
          r: 20,
          b: 45,
          t: 55,
          pad: 4,
        },
        xaxis: {
          tickfont: {
            size: 9,
          },
          fixedrange: true,

          exponentformat: 'none',
          rangemode: 'tozero',
          // showgrid: false,
          // zeroline: false
        },
        annotations: [
          {
            xref: 'paper',
            yref: 'paper',
            x: 0.48,
            y: -0.14,
            xanchor: 'center',
            yanchor: 'top',
            text: config.CEPII_Source,
            showarrow: false,
            font: {
              family: 'Arial',
              size: 8,
              color: 'rgb(150,150,150)',
            },
          },
          {
            xref: 'paper',
            yref: 'paper',
            x: 0.98,
            y: -0.07,
            xanchor: 'center',
            yanchor: 'top',
            text:
                this.app_data.value_mulitplier['prefix'] +
                ' ' +
                this.app_data.exchange_rate['Currency'].slice(0, 3),
            showarrow: false,
            font: {
              family: 'Arial',
              size: 11,
              color: 'rgb(34,34,34)',
            },
          },
        ],
      };
    },
  },

  data: function () {
    return {
      options: {
        responsive: true,
        displayModeBar: false,
      },
    };
  },
};
</script>
